// export const RESTOCKING_FEE = 'restocking_fee';
export const COMPLETE = 'complete';
export const CUSTOM = 'custom';
export const CHARGEBACK = 'chargeback';
export const TYPES = [COMPLETE, CUSTOM];

export const RESTOCKING_FEE_STEPS = ['overview', 'confirm', 'confirm_reason', 'success'];
export const COMPLETE_STEPS = ['overview', 'confirm', 'confirm_reason', 'success'];
export const CUSTOM_STEPS = ['overview', 'confirm', 'confirm_reason', 'success'];
export const CHARGEBACK_STEPS = ['confirm', 'confirm_reason', 'success'];

export const PERCENTAGE_THRESHOLDS = {
	acceptable: 2,
	warning: 2.99,
	critical: 3,
};

export default {};
